import React, { useEffect, useState, useRef, useCallback } from "react";
import { Route, Redirect } from "react-router-dom";
import AuthenticationService from "./AuthenticationService";
import API_CONFIG from "@safecv/src/api-config";
import toast from "@safecv/shared/toast";
import { USER_NAME_SESSION_ATTRIBUTE_NAME } from "@safecv/shared/appConstant";

function AuthenticatedRoute(props) {
  const socket = props.socket;
  const [isConnected, setIsConnected] = useState(false);
  let count = 0;
  let sharedRoute = props.location.pathname + props.location.search;

  useEffect(() => {
    // Websocket connection
    if (AuthenticationService.isUserLoggedInAndTokenRegistered())
      wsConnect(localStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME));
  }, []);

  const wsConnect = useCallback((username) => {
    count = count + 1;
    if (socket.current?.readyState !== WebSocket.OPEN && API_CONFIG.WS_URL) {
      socket.current = new WebSocket(API_CONFIG.WS_URL + "?userId=" + username);
      socket.current.addEventListener("open", onSocketOpen);
      socket.current.addEventListener("close", onSocketClosed);
      socket.current.addEventListener("message", (event) => {
        onSocketMessage(event.data);
      });
    }
  }, []);

  const onSocketOpen = useCallback(() => {
    // let username = localStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
    setIsConnected(true);
    console.log("Websocket connected");
    count = 0;
    // socket.current.send(
    //   JSON.stringify({
    //     action: "publishAll",
    //     username,
    //   })
    // );
  }, []);

  const onSocketClosed = () => {
    setIsConnected(false);
    if (count < 5)
      setTimeout(() => {
        wsConnect(localStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME));
      }, 1000);
    else {
      toast.info("Error connecting to Websocket");
      console.error("Error connecting to Websocket");
    }
  };

  const isJsonString = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  const onSocketMessage = useCallback((dataStr) => {
    console.log(dataStr); //This is to log all the socket messages to the console. Both success and error.
    if (!isJsonString(dataStr)) {
      toast.success(dataStr, { autoClose: false });
    }
  }, []);

  if (/[?&]reviewer=/.test(sharedRoute)) {
    localStorage.clear();
    return (
      <Redirect to={{ pathname: "/", state: { sharedRoute: sharedRoute } }} />
    );
  }

  if (AuthenticationService.isUserLoggedInAndTokenRegistered()) {
    return <Route {...props} />;
  } else {
    localStorage.clear();
    return (
      <Redirect to={{ pathname: "/", state: { sharedRoute: sharedRoute } }} />
    );
  }
}

export default AuthenticatedRoute;
